export default __webpack_public_path__ + "static/media/logo-vinho.300e164f.png";